import { css } from '@emotion/react';
import styled from '@emotion/styled';

export const Input = styled.input`
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
`;

export const Label = styled.label<{ disabled: boolean; hasError: boolean }>`
  border: 2px solid ${(props) => props.theme.color.light.shade};
  padding: 20px;
  font-size: 16px;
  height: 100%;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  ${(props) => props.hasError && `border: 2px solid ${props.theme.color.red.default} !important;`}

  color: ${(props) => props.theme.color.dark.default};
  background: ${(props) =>
    props.disabled ? props.theme.color.light.shadeLighter : props.theme.color.light.tint};
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
`;

export const IconOnlyLabel = styled.label<{ disabled: boolean; hasError: boolean }>`
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
`;
export const Overlay = styled.div`
  transition: all 0.2s ease-in-out;
  opacity: 0;
  border-radius: 10px;

  &:hover {
    opacity: 1;
    transition: all 0.2s ease-in-out;
  }

  bottom: 0px;
  left: 0px;
  right: 0px;
  top: 0px;
  position: absolute;
  z-index: 0;
  padding: 20px;

  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  font-weight: 700;
  font-size: 16px;

  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
`;

export const IconWrapper = styled.div`
  /* margin-bottom: 10px; */
  font-size: 32px;
`;

export const Subtitle = styled.div`
  color: ${(props) => props.theme.color.medium.default};
  font-size: 14px;
`;

export const MainImage = styled.div<{ src: string }>`
  background: url(${(props) => props.src}) center center no-repeat;
  background-size: cover;
  cursor: pointer;
  width: 100%;
  height: 100%;
  border-radius: 10px;
  position: relative;
`;

export const MainImageClearWrapper = styled.div`
  position: absolute;
  top: -10px;
  right: -10px;
  border-radius: 100%;
  background: ${(props) => props.theme.color.light.shade};
  color: ${(props) => props.theme.color.light.default};
  font-weight: 700;
  font-size: 15px;
  width: 25px;
  height: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const FileLoadingStyle = css`
  width: 30px;
`;
